import { ROUTE_NAMES } from "@root/constants";
import { GlobalContextProvider } from "@root/context/global-context";
import SuperAdminLayout from "@root/layouts/SuperAdminLayout";
import { OrganizationsScreen } from "@root/pages/super-admin/organizations/organizationsScreen";
import { createBrowserRouter, Navigate } from "react-router-dom";

export const superAdminRoutes = createBrowserRouter([
    {
        path: "/super-admin",
        element: (
            <GlobalContextProvider>
                <SuperAdminLayout />
            </GlobalContextProvider>
        ),
        children: [
            {
                path: "",
                element: <Navigate to={ROUTE_NAMES.SUPER_ADMIN_ORGANIZATIONS} />,
            },
            {
                path: "organizations",
                element: <OrganizationsScreen />,
            },
        ],
    },
    {
        path: "*",
        element: <Navigate to={ROUTE_NAMES.SUPER_ADMIN_ORGANIZATIONS} />,
    },
]);
